var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrainingSession = function SvgTrainingSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.977978 13.9467C0.11867 13.5986 0.118668 12.4014 0.977977 12.0533L15.541 6.15423C16.0486 5.94859 16.6184 5.94859 17.126 6.15423L31.689 12.0533C32.5483 12.4014 32.5483 13.5986 31.689 13.9467L17.126 19.8458C16.6184 20.0514 16.0486 20.0514 15.541 19.8458L0.977978 13.9467Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 17.7345V20.7449C6.3335 20.9918 6.43027 21.2283 6.61569 21.3913C7.60369 22.2603 11.1314 25 16.3335 25C21.5356 25 25.0633 22.2603 26.0513 21.3913C26.2367 21.2283 26.3335 20.9918 26.3335 20.7449L26.3335 17.7345L17.6892 21.2361C16.8203 21.588 15.8467 21.588 14.9778 21.2361L6.3335 17.7345Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66646 20.8461V16.249L3.99979 16.7891V20.8461L4.72187 23.0957C5.02404 24.0371 4.32183 25 3.33313 25C2.34443 25 1.64221 24.0371 1.94438 23.0957L2.66646 20.8461Z",
    fill: "currentColor"
  })));
};
export default SvgTrainingSession;